import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../index";
import { useUser } from "../hooks";

export interface MenuItem {
    label: string;
    isHeader?: boolean;
    id?: string;
    icon?: string;
    link?: string;
    stateVariables?: boolean;
    click?: (e: React.MouseEvent) => void;
    subItems?: Array<{
      id: string;
      label: string;
      link: string;
      parentId: string;
    }>;
}
  
const Navdata = () => {
    const history = useNavigate();
    const jobs = useSelector((state: RootState) => state.Jobs?.jobs || []);
    const { contractor } = useUser();

    const [isDashboard, setIsDashboard] = useState(false);
    const [isContracts, setIsContracts] = useState(false);
    const [isJobs, setIsJobs] = useState(false);
    const [iscurrentState, setIscurrentState] = useState("Dashboard");

    const contractJobs = Array.isArray(jobs) ? jobs.filter(job => job.contractId) : [];
    const allJobs = Array.isArray(jobs) ? jobs : [];

    function updateIconSidebar(e: React.MouseEvent) {
        if (e && e.target && (e.target as HTMLElement).getAttribute("sub-items")) {
            const ul = document.getElementById("two-column-menu");
            if (ul) {
                const iconItems = ul.querySelectorAll(".nav-icon.active");
                const activeIconItems = Array.from(iconItems);
                activeIconItems.forEach((item) => {
                    item.classList.remove("active");
                    const id = item.getAttribute("sub-items");
                    if (id) {
                        const getID = document.getElementById(id);
                        if (getID) {
                            getID.classList.remove("show");
                        }
                    }
                });
            }
        }
    }

    useEffect(() => {
        document.body.classList.remove("twocolumn-panel");
        setIsDashboard(iscurrentState === "Dashboard");
        setIsContracts(iscurrentState === "Contracts");
        setIsJobs(iscurrentState === "Jobs");
    }, [iscurrentState]);

    const dashboardSubItems = [
        {
            id: "hiring",
            label: "Hiring Dashboard",
            link: "/dashboard",
            parentId: "dashboard",
        },
        {
            id: "contractors-list",
            label: "Contractor List",
            link: "/contractors-list",
            parentId: "dashboard",
        }
    ];

    if (contractor) {
        dashboardSubItems.push({
            id: "contractor",
            label: "Contractor Dashboard",
            link: "/dashboard-contractor",
            parentId: "dashboard",
        });
    }

    const menuItems: MenuItem[] = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Dashboards",
            icon: "mdi mdi-speedometer",
            link: "/#",
            stateVariables: isDashboard,
            click: function (e: React.MouseEvent) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState("Dashboard");
                updateIconSidebar(e);
            },
            subItems: dashboardSubItems,
        },
        {
            id: "contracts",
            label: "Contracts",
            icon: "mdi mdi-file-sign",
            link: "/#",
            stateVariables: isContracts,
            click: function (e: React.MouseEvent) {
                e.preventDefault();
                setIsContracts(!isContracts);
                setIscurrentState("Contracts");
                updateIconSidebar(e);
            },
            subItems: contractJobs.map(job => ({
                id: `contract-${job.id}`,
                label: job.jobTitle,
                link: `/contract/${job.contractId}`,
                parentId: "contracts",
            })),
        },
        {
            id: "jobs",
            label: "Jobs",
            icon: "mdi mdi-briefcase-outline",
            link: "/#",
            stateVariables: isJobs,
            click: function (e: React.MouseEvent) {
                e.preventDefault();
                setIsJobs(!isJobs);
                setIscurrentState("Jobs");
                updateIconSidebar(e);
            },
            subItems: allJobs
                .filter(job => job.id !== 'add-job-card')
                .map(job => ({
                    id: `job-${job.id}`,
                    label: job.jobTitle,
                    link: `/job-detail/${job.id}`,
                    parentId: "jobs",
                })),
        },
    ];

    return menuItems;
};

export const getMenuItems = (): MenuItem[] => {
    const menuItems = Navdata();
    return Array.isArray(menuItems) ? menuItems : [];
};

export default Navdata;